import { validateToken, redirectToLogin } from '../../../utils/auth/tokenValidation';
import { NOTIFY_SMTP_START, NOTIFY_SMTP_DATA, NOTIFY_SMTP_UPSERT, NOTIFY_SMTP_DELETE, NOTIFY_SMTP_END } from '../type';

type Dispatch = (action: { type: string; payload?: any; loading?: boolean }) => void;

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('loginToken')}`,
});

export const getNotifySmtpConfig = () => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) { redirectToLogin(); return; }
  dispatch({ type: NOTIFY_SMTP_START, loading: true });
  try {
    const res = await fetch(`${API_URL}/api/notification-configuration/get`, {
      method: 'GET',
      headers: authHeaders(),
    });
    const data = await res.json();
    if (res.ok) {
      dispatch({ type: NOTIFY_SMTP_DATA, payload: data, loading: false });
      return { success: true, data };
    }
    dispatch({ type: NOTIFY_SMTP_END, payload: data, loading: false });
    return { success: false, data };
  } catch {
    dispatch({ type: NOTIFY_SMTP_END, payload: null, loading: false });
    return { success: false };
  }
};

export const upsertNotifySmtpConfig = (payload: any) => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) { redirectToLogin(); return; }
  dispatch({ type: NOTIFY_SMTP_START, loading: true });
  try {
    const res = await fetch(`${API_URL}/api/notification-configuration/upsert`, {
      method: 'PUT',
      headers: authHeaders(),
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (res.ok) {
      dispatch({ type: NOTIFY_SMTP_UPSERT, payload: data, loading: false });
      return { success: true, data };
    }
    dispatch({ type: NOTIFY_SMTP_END, payload: data, loading: false });
    return { success: false, message: data?.message };
  } catch (e: any) {
    dispatch({ type: NOTIFY_SMTP_END, payload: null, loading: false });
    return { success: false, message: e.message };
  }
};

export const deleteNotifySmtpConfig = () => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) { redirectToLogin(); return; }
  dispatch({ type: NOTIFY_SMTP_START, loading: true });
  try {
    const res = await fetch(`${API_URL}/api/notification-configuration`, {
      method: 'DELETE',
      headers: authHeaders(),
    });
    const data = await res.json();
    if (res.ok) {
      dispatch({ type: NOTIFY_SMTP_DELETE, payload: data, loading: false });
      return { success: true };
    }
    dispatch({ type: NOTIFY_SMTP_END, payload: data, loading: false });
    return { success: false, message: data?.message };
  } catch (e: any) {
    dispatch({ type: NOTIFY_SMTP_END, payload: null, loading: false });
    return { success: false, message: e.message };
  }
};
